var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnitedKingdom(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.5,
    cy: 9,
    fill: "#F0F0F0",
    rx: 9.5,
    ry: 9
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0052B4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.72 3.344A9.073 9.073 0 0 0 .032 6.576h5.102L1.72 3.344zM18.969 6.576a9.073 9.073 0 0 0-1.69-3.232l-3.412 3.232h5.102zM.031 11.424a9.074 9.074 0 0 0 1.69 3.232l3.412-3.232H.03zM15.47 1.63a9.997 9.997 0 0 0-3.412-1.6v4.833L15.47 1.63zM3.53 16.37a9.997 9.997 0 0 0 3.412 1.6v-4.833L3.53 16.37zM6.942.03C5.687.35 4.532.9 3.53 1.63l3.412 3.233V.03zM12.058 17.97a9.997 9.997 0 0 0 3.412-1.6l-3.412-3.233v4.833zM13.867 11.424l3.412 3.232a9.073 9.073 0 0 0 1.69-3.232h-5.102z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.92 7.826h-8.18V.076a10.12 10.12 0 0 0-2.48 0v7.75H.08a8.619 8.619 0 0 0 0 2.348h8.18v7.75a10.12 10.12 0 0 0 2.48 0v-7.75h8.18a8.618 8.618 0 0 0 0-2.348z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.978 11.348l4.24 4.016c.194-.185.38-.378.558-.578l-3.63-3.438h-1.168zM7.022 11.348l-4.24 4.016c.195.185.4.36.61.529l3.63-3.438v-1.107zM7.022 6.652l-4.24-4.016a9.224 9.224 0 0 0-.558.578l3.63 3.438h1.168zM11.978 6.652l4.24-4.016a9.345 9.345 0 0 0-.61-.529l-3.63 3.438v1.107z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnitedKingdom);
export default __webpack_public_path__ + "static/media/united-kingdom.b4e25d08.svg";
export { ForwardRef as ReactComponent };